import LegalDoc from "@/components/LegalDoc";
import { PAYMENT_POLICY } from "@/legal/payment-policy";

export default function PaymentPolicy() {
  return (
    <LegalDoc
      doc={PAYMENT_POLICY}
      related={[
        { to: "/terms/planner", label: "Customer Terms of Service" },
        { to: "/terms/vendor", label: "Vendor Agreement" },
        { to: "/privacy", label: "Privacy Policy" },
      ]}
    />
  );
}
